export const contactIcons = [
  {
    name: "GitHub",
    icon: "bi-github",
    link: "https://github.com/spanol",
  },
  {
    name: "LinkedIn",
    icon: "bi-linkedin",
    link: "https://linkedin.com/in/vinicius-spanol",
  },
]